import React from 'react';
import {StyledSecondaryActionButton} from "./SecondaryActionButton.styled";

interface SecondaryActionButtonProps {
    onClick: () => void;
    disabled?: boolean;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    children?: React.ReactNode;
}

const SecondaryActionButton = ({
    onClick,
    disabled = false,
    startIcon,
    endIcon,
    children,
}: SecondaryActionButtonProps) => {
    return (
        <StyledSecondaryActionButton
            variant="outlined"
            startIcon={startIcon ?? <></>}
            endIcon={endIcon ?? <></>}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </StyledSecondaryActionButton>
    );
};

export default SecondaryActionButton;